import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IWidgetQuery } from '../interfaces/widget.query.interface';
import { WidgetCommand } from '../models/widget.command.model';
import { MaxBrainWidget } from '../models/widget.model';

@Injectable()
export class WidgetApiService extends EntityService<IWidgetQuery, WidgetCommand> implements IEntityApiService<MaxBrainWidget> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'engage/widgets');
    }

    getAll(): Observable<MaxBrainWidget[]> {
        return this.http.get<IWidgetQuery[]>(`${this.apiUrl}/${this.entities}`).pipe(map((queries) => queries.map((query) => new MaxBrainWidget(query))));
    }

    create(entity: MaxBrainWidget): Observable<MaxBrainWidget> {
        const data = new WidgetCommand(entity);

        return this._create(data).pipe(map((query) => new MaxBrainWidget(query)));
    }

    read(id: string): Observable<MaxBrainWidget> {
        return this._read(id).pipe(map((query) => new MaxBrainWidget(query)));
    }

    update(entity: MaxBrainWidget): Observable<MaxBrainWidget> {
        const data = new WidgetCommand(entity);

        return this._update(entity.id, data).pipe(map((query) => new MaxBrainWidget(query)));
    }

    delete(id: string): Observable<any> {
        return this._delete(id);
    }
}
